export const CountDownUnavailableWrapper = `flex flex-col gap-4 items-center`

export const CountDownText = `text-base lg:text-2xl`
